import {useTranslation} from "react-i18next";

export default function SimSingleMultiQuestion({ sim, setSim, setQuestion, question }) {
    const { t, i18n } = useTranslation();
    const isCorrect = (answers) => {
        var correct = 0;
        answers.forEach((answer, idx) => {
            if(question.correct.indexOf(answer) !== -1)
                correct++;
        });

        return correct === question.correct.length
    }
    const selectAnswer = (idx) => {
        if(sim.finished)
            return

        const ans = question.correct.length <= 1 ? [] : [...question.answer]
        const index = ans.indexOf(idx)
        if(index === -1)
            ans.push(idx)
        else
            ans.splice(index, 1)

        setQuestion(sim.currentQuestion, {...question, answer: ans, is_correct: isCorrect(ans) })
    }

    const good = isCorrect(question.answer)
    return (
        <div className={"exam-sim-question " + (question.image_uri ? 'has-image' : '')}>
            <h2 className="exam-sim-question-title">
                {question.question}
            </h2>
            <div className="exam-sim-question-body">
                <div className="exam-sim-question-image">
                    <img src={question.image_uri} alt="" />
                </div>
                <ul className="exam-sim-question-answers">
                    {question.answers.map((answer, idx) => {
                        let c = []
                        if(question.answer !== null && question.answer?.indexOf(idx) !== -1)
                            c.push('selected')
                        if(question.correct.indexOf(idx) !== -1 && sim.finished)
                            c.push('correct')
                        if(process.env.REACT_APP_DEBUG_MODE === "true" && question.correct.indexOf(idx) !== -1)
                            c.push('hack')
                        return <li key={idx} className={c.join(' ')}>
                            <button type="button" onClick={() => selectAnswer(idx)}>{answer}</button>
                        </li>
                    })}
                    {sim.finished && question.explanation !== '' && <li className={"exam-sim-question-desc " + (good ? 'good' : 'wrong')}>
                        {good ? <h3>{t('good')}</h3> : <h3>{t('wrong')}</h3>}
                        {question.explanation}
                    </li>}
                </ul>

            </div>
        </div>
    );
}
